import { createFileRoute } from '@tanstack/react-router';
import { MonitoringDebug } from '~/components/Debug/MonitoringDebug';

export const Route = createFileRoute('/_public/debug/monitoring')({
  component: MonitoringDebug,
});
